module.exports = __webpack_public_path__ + "static/media/BCS-2Views_4.6be40258.png";